/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ServiceType } from 'shared';

import { EntityId } from '../../types/api/EntityId';

export enum CreateClusterActions {
  OPEN_CREATE_CLUSTER_OVERLAY = 'OPEN_CREATE_CLUSTER_OVERLAY',
  CLOSE_CREATE_CLUSTER_OVERLAY = 'CLOSE_CREATE_CLUSTER_OVERLAY',
}

export type CreateClusterState = {
  isOpen: boolean;
  serviceType: ServiceType;
  organizationId?: EntityId;
  projectId?: EntityId;
  clusterId?: EntityId;
  fromBackup: boolean;
};

export type CreateClusterRequiredParams = {
  serviceType: ServiceType;
};

export type CreateClusterNotRequiredParams = {
  organizationId?: EntityId;
  projectId?: EntityId;
  clusterId?: EntityId;
  fromBackup: boolean;
};

export type CreateClusterParams = CreateClusterRequiredParams & CreateClusterNotRequiredParams;

export type OpenCreateClusterOverlayAction = {
  type: CreateClusterActions.OPEN_CREATE_CLUSTER_OVERLAY;
  payload: {
    serviceType: ServiceType;
    projectId?: EntityId;
    organizationId?: EntityId;
    clusterId?: EntityId;
    fromBackup: boolean;
  };
};

export type CloseCreateClusterOverlayAction = {
  type: CreateClusterActions.CLOSE_CREATE_CLUSTER_OVERLAY;
};

export type CreateClusterActionTypes = OpenCreateClusterOverlayAction | CloseCreateClusterOverlayAction;
